import { Box, Text, Flex, Button, Container } from '@chakra-ui/react';
import Image from 'next/image';
import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';
import ConferenceExampleImage from '@/assets/images/presentation/conference-example.png';

export const GetStartedWithVirtualEvents = () => {
  const { t } = useTranslation();

  return (
    <Box bgColor="gray.900" p={12} textAlign="center">
      <Container>
        <Flex color="white" flexDirection="column" alignItems="center" margin="auto">
          <Image src={ConferenceExampleImage} alt="conference running" />
          <Text mt={8} fontSize={{ base: '2xl', md: '3xl' }} maxW="600px" fontFamily="heading" fontWeight="normal">
            {t('virtualEventsPage.getStartedHeading.0')}
            <Text as="span" fontWeight="bold" fontFamily="heading">
              {t('virtualEventsPage.getStartedHeading.1')}
            </Text>
          </Text>
          <Text maxW="800px" mt={10}>
            {t('virtualEventsPage.getStartedDescription')}
          </Text>
          <Button
            as={NextLink}
            href="/contact-us/conferences"
            variant="solid"
            alignSelf="center"
            mt={8}
            rightIcon={<ArrowIcon />}
          >
            {t('newEventPage.getStarted')}
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};
